var map = {
	"./axiomSpace.png": 72,
	"./calm.png": 78,
	"./dataBricks.png": 79,
	"./discord.png": 74,
	"./epicGames.png": 73,
	"./ericsenzZ.png": 142,
	"./huma.png": 77,
	"./illumio.png": 80,
	"./netSkope.png": 81,
	"./plaid.png": 75,
	"./relativity.png": 70,
	"./solarisBank.png": 76,
	"./spaceX.png": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;